// extracted by mini-css-extract-plugin
export default {"period":"DepositPointsLimitsList_period__wl2n4"};